import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { AdminAuthService } from '../../services/admin-auth.service';

const SSO_ERROR_MESSAGES: Record<string, string> = {
  not_authorized: "Your Microsoft account isn't registered as an admin. Contact an administrator.",
  sso_failed: 'Sign-in failed. Please try again.'
};

@Component({
  selector: 'app-admin-login',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit {
  error = '';
  completingSso = false;

  constructor(
    private apiService: ApiService,
    private adminAuthService: AdminAuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    const errorCode = this.route.snapshot.queryParams['error'];
    this.error = SSO_ERROR_MESSAGES[errorCode] || '';
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['sso'] !== 'success') {
      return;
    }

    // The klemantina_admin_session cookie was already set by the backend's SAML ACS endpoint;
    // this just hydrates the local session state from it.
    this.completingSso = true;
    this.apiService.adminGetCurrentUser().subscribe({
      next: (response) => {
        this.adminAuthService.setSession(response, response.expiresAt);
        const raw = this.route.snapshot.queryParams['returnUrl'] || '';
        const returnUrl = (raw.startsWith('/') && !raw.startsWith('//')) ? raw : '/admin';
        this.router.navigateByUrl(returnUrl);
      },
      error: () => {
        this.completingSso = false;
        this.error = SSO_ERROR_MESSAGES['sso_failed'];
      }
    });
  }

  signInWithMicrosoft(): void {
    // Full browser navigation — the SAML redirect to Azure AD and back requires a full page load.
    window.location.href = this.apiService.adminSsoLoginUrl();
  }
}
